import api from "../lib/axios";
import { cookieName } from "../utils/authSession";

// auth
export const authUsingEventIdAndUser = async (token, eventId) => {
  const res = await api.get(`/auth/authWithEvent/${eventId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },

    validateStatus: () => true,
  });

  return res;
};

// auth otp for site user
export const sendOtpForSiteUser = async (data, type, eventId, ticketId) => {
  let url = `/site/${eventId}/otp/${type}/${data}`;
  const queryParams = [];
  if (ticketId) {
    queryParams.push(`ticket_id=${encodeURIComponent(ticketId)}`);
  }
  if (eventId) {
    queryParams.push(`event_id=${encodeURIComponent(eventId)}`);
  }
  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }
  const res = await api.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// auth verfiy otp with email for site user
export const verifyOTP = async (data, type, otp, eventId, ticketId) => {
  const res = await api.post(
    `/site/${eventId}/login`,
    { data, type, otp, ticket_id: ticketId },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  return res;
};

// auth otp for site user
export const logoutSiteUser = async (eventId) => {
  const res = await api.get(`/site/${eventId}/logout`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

export const clearSiteUserSession = async (eventId) => {
  const res = await api.post(`/site/${eventId}/clear-session`, null, {
    headers: {
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });

  if (typeof document !== "undefined") {
    const hostname = window.location.hostname;
    const hostParts = hostname.split(".");
    const parentLabelCount =
      hostParts.length > 3 && hostParts.slice(-2).join(".") === "co.in" ? 3 : 2;
    const parentDomain =
      hostParts.length > parentLabelCount
        ? `.${hostParts.slice(-parentLabelCount).join(".")}`
        : `.${hostname}`;
    const domains = Array.from(new Set([hostname, `.${hostname}`, parentDomain]));

    const siteCookie = cookieName("siteauthtoken");
    document.cookie = `${siteCookie}=; Max-Age=0; path=/`;
    domains.forEach((domain) => {
      document.cookie = `${siteCookie}=; Max-Age=0; path=/; domain=${domain}`;
    });
  }

  return res;
};

// toggle data sharing
export const toggleDataShare = async (eventId) => {
  const res = await api.get(`/site/${eventId}/toggleDataShare`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// check and get auth user for site
export const getSiteAuthUser = async (eventId) => {
  const res = await api.get(`/site/${eventId}/user`, {
    headers: {
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });

  return res;
};

// this is for dashboard to get user info
export const getUserByEmail = async (email) => {
  if (!email || email === "undefined" || email === "null") {
    return {
      status: 400,
      ok: false,
      json: async () => ({ message: "failure", errorMessage: "Invalid email" }),
    };
  }
  const res = await fetch(`/auth/getuser/${email}`, {
    headers: {
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });

  return res;
};

export const getUser = async (email) => {
  const res = await api.get(`/auth/getuser/${email}`);
  return res;
};

export const updateUserDetails = async (formData) => {
  const res = await api.put("/auth/updateUserDetails", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const subscribeNow = async (body) => {
  const res = await api.post("/auth/subscribeNow", body);
  return res;
};

export const logoutUser = async () => {
  const res = await api.post("/auth/logout", {}, { withCredentials: true });
  return res;
};

export const verifyOtp = async (body) => {
  const res = await api.post("/auth/verifyOtp", body, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const register = async (body) => {
  const res = await api.post("/auth/register", body, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAuthMe = async () => {
  const res = await api.get(`/auth/me`, {
    timeout: 15000,
    retryOnTemporaryError: true,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const login = async (body) => {
  const res = await api.post("/auth/login", body, {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const googleSignup = async (body) => {
  const res = await api.post("/auth/google-signup", body, {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const registerUser = async (body) => {
  const res = await api.post("/auth/register", body, {
    headers: { "ngrok-skip-browser-warning": "true" },
  });
  return res;
};

export const forgotPassword = async (email) => {
  const res = await api.post("/auth/forgot-password", { email });
  return res;
};

export const resetPassword = async (payload) => {
  const res = await api.post("/auth/reset-password", payload, {
    headers: { "ngrok-skip-browser-warning": "true" },
  });
  return res;
};

export const googleSignup2 = async (body) => {
  const res = await api.post("/auth/google-signup", body, {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};
